/* @flow */

import * as React from 'react';

import styles from './ElectrorentLogo.module.scss';

type TypeProps = {
  variant: string,
};

function ElectrorentLogoSVG(props: TypeProps): React.Element<*> {
  return props.variant === 'portal' ? (
    /* eslint-disable max-len */
    <svg
      className={styles['logo-svg-portal']}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 123.447 51.821"
    >
      <path d="M0 0h57.082v51.821H0z" fill="#ffffff" transform="translate(66.365)" />
      <path d="M0 0h66.365v51.821H0z" />
      <path
        d="M33.84 22.164c3.921-3.574 8.637-4.17 12.608-1.638a7.868 7.868 0 0 1 3.872 6.9c.05 2.234 0 4.517 0 6.751 0 3.326 1.787 5.013 5.162 5.113 3.574.1 5.808-1.787 5.907-5.063.05-3.326 0-6.7 0-10.027v-2.135c1.241 0 2.333.05 3.375 0 1.241-.1 1.539.447 1.539 1.638-.05 6.155 0 12.31-.05 18.465a40.634 40.634 0 0 1-.347 6.006c-.844 5.212-6.056 8.538-11.714 7.694-5.41-.844-9.232-5.41-8.587-10.324.5-.05.993-.05 1.489-.1 1.737-.1 3.177-.248 3.524 2.333.3 2.333 3.077 3.475 6.155 3.177a5.18 5.18 0 0 0 4.567-4.666c.1-1.191 0-2.383 0-3.723a12.053 12.053 0 0 1-11.268-.3 8.49 8.49 0 0 1-4.672-7.89v-5.857c0-3.276-1.539-5.113-4.269-5.162-3.177-.05-4.864 1.588-4.914 5.063-.05 4.021 0 8.041 0 12.111v4.219A35.916 35.916 0 0 1 32.2 44.7c-.347-.05-.893-.943-.893-1.439-.05-4.765-.05-9.58-.05-14.345a11.025 11.025 0 0 0-.149-2.234c-.546-2.383-2.333-3.574-5.063-3.326-2.333.2-3.723 1.787-3.723 4.517-.05 4.914 0 9.778 0 14.693V44.7c-1.439 0-2.73.05-4.021-.05a1.365 1.365 0 0 1-.794-.993c-.05-5.758-.2-11.516.05-17.274.149-3.276 2.234-5.609 5.41-6.751a9.381 9.381 0 0 1 9.729 1.39c.399.398.746.795 1.144 1.142z"
        fill="#ffffff"
        transform="translate(-8.773 -9.507)"
      />
      <path
        d="M150.3 16.3h19.358L178 24.639h-18.914v20.6h11.565l8.289 8.24H150.3z"
        fillRule="evenodd"
        transform="translate(-75.696 -8.209)"
      />
      <path
        d="M193.593 32.184l7.5 7.5s10.424-.943 10.424-11.665c0-10.771-11.268-11.714-11.268-11.714H192.7l8.488 8.488s4.07 5.212-1.787 7.4z"
        fillRule="evenodd"
        transform="translate(-97.05 -8.209)"
      />
      <path
        d="M179.266 48.2H167.8l21.493 21.344h11.466z"
        fillRule="evenodd"
        transform="translate(-84.509 -24.275)"
      />
    </svg>
  ) : (
    /* eslint-disable max-len */
    <svg
      className={styles['logo-svg-company']}
      x="0px"
      y="0px"
      viewBox="0 0 216 60"
      xmlSpace="preserve"
    >
      <g className={styles['logo-icon']}>
        <path d="M14,15h15.6l6.7,6.7H21.1v16.6h9.3l6.7,6.6H14V15z" />
        <path d="M31.7,27.8l6,6c0,0,8.4-0.7,8.4-9.4s-9-9.4-9-9.4H31l6.8,6.8c0,0,3.3,4.2-1.4,5.9L31.7,27.8z" />
        <path d="M30.3,27.8H21L38.3,45h9.3L30.3,27.8z" />
      </g>
      <g className={styles['logo-text']}>
        <path
          d="M151.1,40.8l-7.8-7.9c1.3,0,4.3-1.8,4.3-6c0-1.8-0.6-3.5-1.9-4.8c-1.1-1-2.6-1.7-5.4-1.7H134v20.4h3v-9.5h0.1l9.7,9.5
                        L151.1,40.8z M137,23.1h3.1c3.4,0,4.5,2.1,4.5,3.8c0,3.9-4.4,4-5.6,4h-2V23.1z"
        />
        <path
          d="M179.7,40.8v-9.7c0-1.4-0.3-2.7-1-3.9c-1.2-1.8-3.2-2.8-5.4-2.7c-1.7-0.1-3.4,0.7-4.5,2h-0.1v-1.6H166v15.9h2.9v-9
                        c0-3.1,1.6-4.7,4-4.7c3.8,0,3.8,3.6,3.8,4.8v9L179.7,40.8L179.7,40.8z"
        />
        <path
          d="M161.7,34h-7.9l-2.6-2.6c-0.1,0.5-0.2,1-0.2,1.5c0,3,2.4,5.4,5.4,5.4c1.9,0,3.6-1,4.6-2.6h3.1c-1.6,4.1-6.2,6-10.3,4.4
                        s-6-6.2-4.4-10.3s6.2-6,10.3-4.4c3,1.2,5,4.2,5,7.4c0,0.4,0,0.8-0.1,1.1L161.7,34z M156.5,27.4c-2.3,0-4.4,1.5-5.1,3.7h10.2
                        C160.8,28.9,158.8,27.4,156.5,27.4z"
        />
        <path
          d="M80.2,34h-7.8l-2.6-2.6c-0.8,2.9,0.8,5.9,3.7,6.7c0.5,0.1,1,0.2,1.5,0.2c1.9,0,3.6-1,4.6-2.6h3.1c-1.6,4.1-6.2,6-10.3,4.4
                        s-6-6.2-4.4-10.3s6.2-6,10.3-4.4c3,1.2,5,4.2,5,7.4c0,0.4,0,0.8-0.1,1.1L80.2,34z M75,27.4c-2.3,0-4.4,1.5-5.1,3.7H80
                        C79.3,28.9,77.3,27.4,75,27.4z"
        />
        <path d="M186.3,27.9h-2.1v12.9h-3V20.4h3v4.8h2.1V27.9z" />
        <path d="M106.1,27.9H104v12.9h-3V20.4h3v4.8h2.1V27.9z" />
        <path
          d="M110.4,40.8v-8.3c0-2.2,0.8-3.3,1.7-3.8c0.6-0.3,1.3-0.5,2.1-0.6v-2.9c-1.5-0.1-3,0.6-3.9,1.8h-0.1v-1.4h-2.7v15.3
                        L110.4,40.8z"
        />
        <path d="M61.1,38v2.8h-6.8v0.1h-3V20.3h9.8v2.8h-6.8v6.1h6.8V32h-4.3l-2.5-2.3V38H61.1z" />
        <path d="M62.5,20.4h3v20.3h-3V20.4z" />
        <path
          d="M96.9,30.4c-0.9-1.8-2.8-2.9-4.8-2.9c-3,0-5.4,2.5-5.3,5.5c0,2.9,2.4,5.3,5.3,5.3c2,0,3.9-1.1,4.8-2.9h3
                        c-1.4,4.2-5.9,6.4-10.1,5s-6.4-5.9-5-10.1s5.9-6.4,10.1-5c2.4,0.8,4.3,2.7,5,5.1L96.9,30.4z"
        />
        <path
          d="M129.7,32.8c-0.1-4.6-3.9-8.1-8.5-8c-4.3,0.1-7.8,3.6-8,7.9c0,4.5,3.7,8.3,8.2,8.3C126,41,129.7,37.4,129.7,32.8z
                         M126.8,32.8c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4l0,0C124.4,27.4,126.8,29.8,126.8,32.8z"
        />
      </g>
    </svg>
  );
}

export default ElectrorentLogoSVG;
